import React, { Component } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Store from './store'
import Select from '../form/Select'
import ObjectivesGrid from './templates/objectivesGrid'
import RoosChart from './templates/roosChart'
import CombinedGrid from './templates/combinedGrid'
import Button from '../../UniformComponents/Button'

import './styles.scss'

@observer
class TemplateCreation extends Component {
    constructor(props) {
        super(props)

        const { store } = props
        const { templateCreationPageId, survey } = store

        this.templateStore = new Store()
        this.templateStore.init(templateCreationPageId, survey, store)
    }

    close = () => {
        const { onClose } = this.props
        onClose()
    }

    renderTemplate = () => {
        const { templateStore } = this
        const { templateId } = templateStore

        switch (templateId) {
            case 'objectives-grid':
                return (
                    <ObjectivesGrid
                        store={templateStore}
                    />
                )
            case 'roos-chart':
                return (
                    <RoosChart
                        store={templateStore}
                    />
                )
            case 'combined-grid':
                return (
                    <CombinedGrid
                        store={templateStore}
                    />
                )
            default:
                return null
        }
    }

    render() {
        const { store, onClose } = this.props
        const { templateStore } = this
        return (
            <div id="templateCreation">
                <Select
                    options={[
                        {
                            value: 'objectives-grid',
                            label: 'Objectives grid',
                        },
                        {
                            value: 'roos-chart',
                            label: 'Roos chart',
                        },
                        {
                            value: 'combined-grid',
                            label: 'Combined grid',
                        },
                    ]}
                    isClearable
                    blurOnClear
                    onBlur={templateStore.changeTempalate}
                    defaultValue={templateStore.templateId}
                />
                {this.renderTemplate()}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        cssClass="regular tertiary"
                        style={{ marginRight: '25px' }}
                        onClick={this.close}
                        label={i18n.t('cancel')}
                    />
                    <Button
                        cssClass="regular primary"
                        onClick={() => templateStore.save(store, onClose)}
                        label={i18n.t('save')}
                    />
                </div>
            </div>
        )
    }
}

export default TemplateCreation
